// extracted by mini-css-extract-plugin
export default {"content":"style_content__XwCfT","itemName":"style_itemName__rWhw9","leftSide":"style_leftSide__8McyC","rightSide":"style_rightSide__Qc9hI","type":"style_type__vd6Ff"};